import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { presetStatus, screenType, STORAGE_PRESET_DATA_KEY, STORAGE_PRESET_STATUS_KEY } from './constants';
import {
    getSessionSettingsStorage,
    removeSessionSettingsStorage,
    setSessionSettingsStorage
} from '../../store/session-storage';

export const initialPreset = {
    status: presetStatus.IN_PROGRESS,
    currentScreen: screenType.ORDER_TYPE,
    preset: {
        orderType: null,
        orderMethodType: '',
        delivery: {
            address: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            specialInstruction: '',
        },
        schedule: {
            period: '',
            time: '',
        },
    },
};

export const initialSetter = () => {};

const Context = createContext(initialPreset);
const SetterContext = createContext(initialSetter);

export const usePreset = () => {
    const context = useContext(Context);
    
    if (context === 'undefined') {
        throw new Error('Hook [usePreset] must be inside [PresetProvider].');
    }
    
    return context;
};

export const useSetPreset = () => {
    const context = useContext(SetterContext);
    
    if (context === 'undefined') {
        throw new Error('Hook [useSetPreset] must be inside [PresetProvider].');
    }
    
    return context;
};

export const getCheckoutPresetStatus = () => getSessionSettingsStorage(STORAGE_PRESET_STATUS_KEY);
export const getCheckoutPresetData = () => getSessionSettingsStorage(STORAGE_PRESET_DATA_KEY);
export const removeCheckoutPresetStatus = () => removeSessionSettingsStorage(STORAGE_PRESET_STATUS_KEY);
export const removeCheckoutPresetData = () => removeSessionSettingsStorage(STORAGE_PRESET_DATA_KEY);

export const PresetProvider = ({ children }) => {
    const [preset, setPreset] = useState(() => {
        const prevStatus = getCheckoutPresetStatus();
        const existsData = getCheckoutPresetData();
        
        return {
            ...initialPreset,
            ...(!!prevStatus && { status: prevStatus }),
            preset: {
                ...initialPreset.preset,
                ...(!!existsData ?? existsData),
            },
        }
    });
    
    const firstRenderRef = useRef(true);

    useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        
        const prevStatus = getCheckoutPresetStatus();
        if (prevStatus !== preset.status) {
            setSessionSettingsStorage(STORAGE_PRESET_STATUS_KEY, preset.status);
        }
        
        setSessionSettingsStorage(STORAGE_PRESET_DATA_KEY, preset.preset);
    }, [preset]);
    
    return (
        <SetterContext.Provider value={setPreset}>
            <Context.Provider value={preset}>
                {children}
            </Context.Provider>
        </SetterContext.Provider>
    );
};
